import type { BannerPlacement } from 'modules/types'

export type BannerView =
  | { kind: 'service-event'; placement: 'ServiceAccessories' }
  | { kind: 'banner'; placement: BannerPlacement }

type BannerPlacementPolicy = {
  segmentation: boolean
  pageSize: number | null
  canCreate: 'many' | 'once'
  canDelete: boolean
}

export const BANNER_PLACEMENT_POLICY: Record<BannerPlacement, BannerPlacementPolicy> = {
  HomePage: {
    segmentation: true,
    pageSize: null,
    canCreate: 'many',
    canDelete: true
  },
  ServiceAccessories: {
    segmentation: false,
    pageSize: null,
    canCreate: 'many',
    canDelete: true
  },
  CustomerCare: {
    segmentation: false,
    pageSize: 1,
    canCreate: 'once',
    canDelete: false
  }
}
